import { Box, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { KOSTEN_ARTEN, KOSTEN_POSITION, NACHWEIS_POSITION_STATUS, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

import { concat, get } from 'lodash';
import Schema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
import { GetMinDecimalValidation, NonRequired, Required } from 'src/lib/validation/ValidationTypes';
import {
	formStrucPruefAssistenz,
	getNachweisAusgabenPath,
	getNachweisPruefAssistenzPaths,
	shouldValidatePruefAssistenz,
} from '../../content/helpers/projekteausgabenNachweisHelper';
const MA_P = Schema.attributes;
const NP_P = NachweisPositionSchema.attributes;
const STIPENDIUM_PROJEKTAUSGABEN_GESAMT_PATH = 'stipendiumProjektausgabenGesamt';
const STIPENDIUM_BEMESSUNGSGRUNDLAGE_PATH = 'stipendiumBemessungsgrundlage';

export const ProjektausgabenMAStipendium = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const angefallenPath = getNachweisAusgabenPathByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const anfallendePath = getNachweisAusgabenPathByStatus(application, NACHWEIS_POSITION_STATUS.geplant);
	const eigenmittelPosition = getEinnahmePositionByKostenart(application, KOSTEN_ARTEN.Eigenmittel);
	const oeffentlicheMittelPosition = getEinnahmePositionByKostenart(application, KOSTEN_ARTEN.OeffentlicheMittel);
	const einnahmePositionen = [
		{ position: eigenmittelPosition, formStrucByPath: formStrucEinnahmeEigenmittelByPath },
		{ position: oeffentlicheMittelPosition, formStrucByPath: formStrucEinnahmeOeffentlicheMittelByPath },
	].filter((entry) => Boolean(entry.position)) as any[];
	const eigenUndDrittmittelPositionen = einnahmePositionen.map((entry) => entry.position);
	const angefalleneAusgaben = Number(get(application, angefallenPath, 0)) || 0;
	const anfallendeAusgaben = Number(get(application, anfallendePath, 0)) || 0;
	const eigenUndDrittmittelGesamt = eigenUndDrittmittelPositionen.reduce(
		(acc: number, eachPosition: any) => acc + (Number(get(eachPosition, NP_P.Allgemein_Ausgaben_Kosten.path, 0)) || 0),
		0,
	);
	const gesamtAusgaben = angefalleneAusgaben + anfallendeAusgaben;
	const bemessungsgrundlage = gesamtAusgaben - eigenUndDrittmittelGesamt;
	const pruefAssistenzPathsAngefallen = getPruefAssistenzPathsByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const pruefAssistenzPathsAnfallende = getPruefAssistenzPathsByStatus(application, NACHWEIS_POSITION_STATUS.geplant);
	const labelSx = { width: { md: '30rem' }, pt: '10px' };
	const strongLabelSx = { ...labelSx, fontWeight: 600 };
	const formSx = { width: { xs: '100%', md: '22rem' } };
	// const currentHaushaltsjahr = get(application, MA_P.Allgemein_Haushaltsjahr.path);

	return (
		<>
			<ApplicationHeading title={'Projektausgaben'} description={PLATZHALTER_TEXT} />
			<Typography sx={{ fontWeight: 600, mb: 2 }}>
				Bitte geben Sie hier die Höhe der für den Zuwendungszweck bestimmten Ausgaben an, die im betrachteten Haushaltsjahr
			</Typography>
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
				<PruefAssistenz
					statusPath={pruefAssistenzPathsAngefallen.statusPath}
					hinweisPath={pruefAssistenzPathsAngefallen.hinweisPath}
					ueberarbeitetAmPath={pruefAssistenzPathsAngefallen.ueberarbeitetAmPath}
					erledigtPath={pruefAssistenzPathsAngefallen.erledigtPath}
					formStruc={formStrucPruefAssistenz(pruefAssistenzPathsAngefallen.erledigtPath)}
				/>
				<Grid2 container columnSpacing={2} rowSpacing={1} alignItems={'flex-start'}>
					<Grid2 xs={12} md={'auto'}>
						<Typography sx={labelSx}>bis jetzt angefallen sind (kumuliert)</Typography>
					</Grid2>
					<Grid2 xs={12} md={'auto'}>
						<Box sx={formSx}>
							<CreateForm
								formValues={application}
								formStruc={formStrucAngefallen(application)}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={readOnly}
							/>
						</Box>
					</Grid2>
				</Grid2>

				<PruefAssistenz
					statusPath={pruefAssistenzPathsAnfallende.statusPath}
					hinweisPath={pruefAssistenzPathsAnfallende.hinweisPath}
					ueberarbeitetAmPath={pruefAssistenzPathsAnfallende.ueberarbeitetAmPath}
					erledigtPath={pruefAssistenzPathsAnfallende.erledigtPath}
					formStruc={formStrucPruefAssistenz(pruefAssistenzPathsAnfallende.erledigtPath)}
				/>
				<Grid2 container columnSpacing={2} rowSpacing={1} alignItems={'flex-start'}>
					<Grid2 xs={12} md={'auto'}>
						<Typography sx={labelSx}>und in den nächsten drei Monaten anfallen werden</Typography>
					</Grid2>
					<Grid2 xs={12} md={'auto'}>
						<Box sx={formSx}>
							<CreateForm
								formValues={application}
								formStruc={formStrucAnfallende(application)}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={readOnly}
							/>
						</Box>
					</Grid2>
				</Grid2>

				<Grid2 container columnSpacing={2} rowSpacing={1} alignItems={'flex-start'}>
					<Grid2 xs={12} md={'auto'}>
						<Typography sx={strongLabelSx}>Gesamt</Typography>
					</Grid2>
					<Grid2 xs={12} md={'auto'}>
						<Box sx={formSx}>
							<CreateForm
								formValues={{ [STIPENDIUM_PROJEKTAUSGABEN_GESAMT_PATH]: gesamtAusgaben }}
								formStruc={formStrucGesamt()}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={true}
							/>
						</Box>
					</Grid2>
				</Grid2>
				{einnahmePositionen.map((entry: any, index: number) => {
					const eachPosition = entry.position;
					const pruefAssistenzPaths = getPruefAssistenzPathsByPosition(application, eachPosition);
					const path = getNachweisAusgabenPathByPosition(application, eachPosition);
					const label =
						get(eachPosition, `${NP_P.Allgemein_Kostenkategorie.path}.attributes.Allgemein_Bezeichnung`, '') ||
						get(eachPosition, NP_P.Allgemein_Bezeichnung.path, '');

					return (
						<React.Fragment key={index}>
							<PruefAssistenz
								statusPath={pruefAssistenzPaths.statusPath}
								hinweisPath={pruefAssistenzPaths.hinweisPath}
								ueberarbeitetAmPath={pruefAssistenzPaths.ueberarbeitetAmPath}
								erledigtPath={pruefAssistenzPaths.erledigtPath}
								formStruc={formStrucPruefAssistenz(pruefAssistenzPaths.erledigtPath)}
							/>
							<Grid2 container columnSpacing={2} rowSpacing={1} alignItems={'flex-start'}>
								<Grid2 xs={12} md={'auto'}>
									<Typography sx={labelSx}>abzügl. {label}</Typography>
								</Grid2>
								<Grid2 xs={12} md={'auto'}>
									<Box sx={formSx}>
										<CreateForm
											formValues={application}
											formStruc={entry.formStrucByPath(path)}
											updateFormValuesFunc={setApplicationProperty}
											readOnly={readOnly}
										/>
									</Box>
								</Grid2>
							</Grid2>
						</React.Fragment>
					);
				})}

				<Grid2 container columnSpacing={2} rowSpacing={1} alignItems={'flex-start'}>
					<Grid2 xs={12} md={'auto'}>
						<Typography sx={strongLabelSx}>Bemessungsgrundlage</Typography>
					</Grid2>
					<Grid2 xs={12} md={'auto'}>
						<Box sx={formSx}>
							<CreateForm
								formValues={{ [STIPENDIUM_BEMESSUNGSGRUNDLAGE_PATH]: bemessungsgrundlage }}
								formStruc={formStrucBemessungsgrundlage()}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={true}
							/>
						</Box>
					</Grid2>
				</Grid2>
			</Box>
		</>
	);
};

const getPruefAssistenzPathsByStatus = (application: any, status: string) => {
	return getNachweisPruefAssistenzPaths(application, (eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
};

const getPruefAssistenzPathsByPosition = (application: any, position: any) => {
	return getNachweisPruefAssistenzPaths(application, (eachPosition: any) => eachPosition === position);
};

const getNachweisAusgabenPathByStatus = (application: any, status: string) => {
	return getNachweisAusgabenPath(application, (eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
};

const getNachweisAusgabenPathByPosition = (application: any, position: any) => {
	return getNachweisAusgabenPath(application, (eachPosition: any) => eachPosition === position);
};

const getEinnahmePositionByKostenart = (application: any, kostenart: string) => {
	const nachweispositionen = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);

	return (nachweispositionen as any[]).find(
		(eachPosition: any) =>
			get(eachPosition, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Einnahme &&
			get(eachPosition, NP_P.Allgemein_Kostenart_Finanzierung.path) === kostenart,
	);
};

const formStrucAngefallen = (application: any) => {
	const path = getNachweisAusgabenPathByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					path,
					label: '',
					format: 'currency',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};
const formStrucAnfallende = (application: any) => {
	const path = getNachweisAusgabenPathByStatus(application, NACHWEIS_POSITION_STATUS.geplant);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					path,
					label: '',
					format: 'currency',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

const formStrucGesamt = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ path: STIPENDIUM_PROJEKTAUSGABEN_GESAMT_PATH, type: 'decimal', label: '', disabled: true, format: 'currency' }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

const formStrucEinnahmeEigenmittelByPath = (path: string) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					path,
					label: '',
					format: 'currency',
					validation: [
						{ validateFunction: Required },
						{ validateFunction: GetMinDecimalValidation, params: [1, 'Der Mindestwert beträgt 1,00 €.'] },
					],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

const formStrucEinnahmeOeffentlicheMittelByPath = (path: string) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					path,
					label: '',
					format: 'currency',
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

const formStrucBemessungsgrundlage = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ path: STIPENDIUM_BEMESSUNGSGRUNDLAGE_PATH, type: 'decimal', label: '', format: 'currency', disabled: true }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

export const getFormstrucProjektausgabenMAStipendium = (application: any) => {
	let struc: FormStrucItem[] = [];
	const pruefAssistenzPathsAngefallen = getPruefAssistenzPathsByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben);
	const pruefAssistenzPathsAnfallende = getPruefAssistenzPathsByStatus(application, NACHWEIS_POSITION_STATUS.geplant);
	const eigenmittelPosition = getEinnahmePositionByKostenart(application, KOSTEN_ARTEN.Eigenmittel);
	const oeffentlicheMittelPosition = getEinnahmePositionByKostenart(application, KOSTEN_ARTEN.OeffentlicheMittel);
	const einnahmePositionen = [
		{ position: eigenmittelPosition, formStrucByPath: formStrucEinnahmeEigenmittelByPath },
		{ position: oeffentlicheMittelPosition, formStrucByPath: formStrucEinnahmeOeffentlicheMittelByPath },
	].filter((entry) => Boolean(entry.position)) as any[];
	const eigenUndDrittmittelPositionen = einnahmePositionen.map((entry) => entry.position);
	const pruefAssistenzPathsEigenUndDrittmittel = eigenUndDrittmittelPositionen.map((eachPosition: any) =>
		getPruefAssistenzPathsByPosition(application, eachPosition),
	);
	const shouldValidateAngefallen = shouldValidatePruefAssistenz(application, pruefAssistenzPathsAngefallen);
	const shouldValidateAnfallende = shouldValidatePruefAssistenz(application, pruefAssistenzPathsAnfallende);
	const shouldValidateEigenUndDrittmittel = pruefAssistenzPathsEigenUndDrittmittel.filter((eachPath: any) =>
		shouldValidatePruefAssistenz(application, eachPath),
	);

	if (shouldValidateAngefallen) {
		struc = concat(struc, formStrucPruefAssistenz(pruefAssistenzPathsAngefallen.erledigtPath));
	}

	if (shouldValidateAnfallende) {
		struc = concat(struc, formStrucPruefAssistenz(pruefAssistenzPathsAnfallende.erledigtPath));
	}

	shouldValidateEigenUndDrittmittel.forEach((eachPath: any) => {
		struc = concat(struc, formStrucPruefAssistenz(eachPath.erledigtPath));
	});

	struc = concat(
		struc,
		formStrucAngefallen(application),
		formStrucAnfallende(application),
		...einnahmePositionen.map((entry: any) => entry.formStrucByPath(getNachweisAusgabenPathByPosition(application, entry.position))),
	);
	return struc;
};
